import { withStyles } from "@material-ui/core/styles";
import SplashScreen from "./SplashScreen";
import styles from "./styles";

export default withStyles(styles)(SplashScreen);
